import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ApiService } from './api.service';
import {
  AppVersionConfigService,
  RestConfig,
  RestConfigService,
} from './config';
import { RequestCacheService } from '@core/api/data-services';
import {
  ApiKeyInterceptor,
  ApiVersionInterceptor,
  CacheInterceptor,
  LocaleInterceptor,
} from './interceptors';

@NgModule({
  declarations: [],
  imports: [CommonModule],
})
export class ApiModule {
  static forRoot(
    rest: RestConfig,
    appVersion: string
  ): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: AppVersionConfigService,
          useValue: appVersion,
        },
        {
          provide: RestConfigService,
          useValue: rest,
        },
        ApiService,
        RequestCacheService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ApiVersionInterceptor,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: LocaleInterceptor,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ApiKeyInterceptor,
          multi: true,
        },
        { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
      ],
    };
  }
}
